/* FifteenFold / Hayati Essence: Atmospheres, one preference across all storefront pages. */
(function(){
  'use strict';
  var KEY='hayati-atmosphere-v1';
  var root=document.documentElement;
  var buttons=Array.prototype.slice.call(document.querySelectorAll('[data-he-atmosphere-toggle]'));
  function update(mode,persist){
    mode=mode==='night'?'night':'day';
    root.setAttribute('data-he-atmosphere',mode);
    root.style.colorScheme=mode==='night'?'dark':'light';
    if(persist){try{localStorage.setItem(KEY,mode);}catch(e){}}
    buttons.forEach(function(button){
      var night=mode==='night';
      var next=night?'Daylight':'After Dark';
      button.setAttribute('aria-pressed',night?'true':'false');
      button.setAttribute('aria-label','Switch to '+next+' atmosphere');
      button.setAttribute('title','Switch to '+next);
      var label=button.querySelector('[data-he-atmosphere-label]');
      if(label)label.textContent=night?'After Dark':'Daylight';
    });
    document.querySelectorAll('[data-he-atmosphere-description]').forEach(function(el){
      el.textContent=mode==='night'?'Discover the collection after dark.':'Explore Hayati Essence in a softer light.';
    });
    var themeColor=document.querySelector('meta[name="theme-color"]');
    if(themeColor)themeColor.setAttribute('content',mode==='night'?'#171511':'#f8f6f2');
  }
  update(root.getAttribute('data-he-atmosphere'),false);
  buttons.forEach(function(button){
    button.addEventListener('click',function(){
      update(root.getAttribute('data-he-atmosphere')==='night'?'day':'night',true);
    });
  });
  window.addEventListener('storage',function(event){
    if(event.key===KEY){update(event.newValue,false);}
  });
})();
